import { createContext, Dispatch, SetStateAction } from "react";

import { noop, ViewDto } from "@ryde/shared";

interface IDashboardViewContext {
  isEditViewOpen: boolean;
  openEditView: (viewDto?: ViewDto) => void;
  editView: ViewDto | undefined;
  isDropdownOpen: boolean;
  setIsDropdownOpen?: Dispatch<SetStateAction<boolean>>;
}

export const DashboardViewContext = createContext<IDashboardViewContext>({
  isEditViewOpen: false,
  editView: undefined,
  openEditView: noop,
  isDropdownOpen: false,
});
